/**
 * Enrollment write operations (DIP: UI depends on this module, not axios details).
 * Swap or mock this module in tests.
 */
import { enrollmentsAPI } from '../../services/api';

export const enrollmentCommands = {
  async createAdditionalEnrollment(payload) {
    return enrollmentsAPI.create(payload);
  },

  async changeBatch(payload) {
    return enrollmentsAPI.changeBatch(payload);
  }
};
